import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-speed",
  "use": "icon-speed-usage",
  "viewBox": "0 0 10 14",
  "content": "<symbol viewBox=\"0 0 10 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-speed\">\n<path d=\"M6.4 0L0 8.4H3.8L2.7 14L9.2 5.6H5.2L6.4 0Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/speed.svg
// module id = wYLz
// module chunks = 262